<app-card  [hidHeader]="true">
    <br>
    <h2 style="text-align:center;"><strong>Hipertensão</strong></h2>

<p>Equipe Editorial Bibliomed Neste artigo:</p>

<p>- Introdução</p>

<p>- Causas e fatores de risco</p>

<p>- Sintomas</p>

<p>- Diagnóstico</p>

<p>- Tratamento</p>

<p>- Prevenção</p>
<p align="center">
    <button  type="button" class="btn btn-warning " style="margin-right: 30px;">
        <i  class="feather icon-smartphone mr-2 f-20"></i>
   
         Notificação no Aplicativo </button>

        <button  type="button" class="btn btn-success " >
            <i class="fab fa-whatsapp mr-2 f-24"></i>  Mensagem de Whatsapp </button>
</p>

<p><b>Introdução</b>  </p>

<p>A hipertensão arterial, também conhecida como pressão alta, é uma doença crônica caracterizada pelos níveis elevados da pressão sanguínea nas artérias. Para que a pressão seja considerada alta, as medidas devem ser iguais ou maiores a 140/90mmHg (ou 14 por 9) na maior parte do tempo. Algumas associações médicas estão adotando medidas ainda mais baixas, como 130/80mmHg, para considerar uma pessoa hipertensa. Em pessoas com essa condição, o coração precisa se esforçar mais para fazer a distribuição do sangue pelo corpo.</p>

<p>A medição da pressão arterial é feita através de um aparelho chamado esfigmomanômetro, que é posicionado em volta do braço, em conjunto com um estetoscópio. Com esses aparelhos, o profissional registra a pressão sistólica (ou máxima) que é o momento em que o coração libera o sangue. No segundo momento, mede-se a pressão diastólica (ou mínima).</p>

<p>De acordo com dados do Sistema de Vigilância de Fatores de Risco e Proteção para Doenças Crônicas por Inquérito Telefônico (Vigitel 2018), 24,7% da população que vive nas capitais brasileiras afirmaram ter diagnóstico para hipertensão, sendo os idosos os mais afetados: 60,9% dos entrevistados com mais de 65 anos e 49,5% com idade entre 55 e 64 anos afirmaram ser hipertensos.</p>

<p>A pesquisa Vigitel 2018 também destacou que a escolaridade afeta diretamente os índices de hipertensão: quanto mais tempo de estudo, menor a taxa de hipertensão. Para se ter uma ideia, do público com menos de oito anos de estudo, 42,5% disse sofrer com a doença; dos com 9 a 11 de estudo, 19,4%; e 12 ou mais, 14,2%.</p>

<p>A hipertensão é um dos principais fatores de risco para a ocorrência de infartos, aneurismas arteriais, acidente vascular cerebral (AVC), e insuficiência renal e cardíaca. Causas e fatores de risco</p>

<p>A hipertensão ocorre quando existe uma resistência e endurecimento maior dos vasos sanguíneos, fazendo com que o coração precise realizar mais força para bombear o sangue. Este pode ser um processo natural do corpo, o que explica o elevado número de idosos hipertensos, mas alguns fatores de risco podem aumentar a probabilidade de se desenvolver hipertensão, como: obesidade; sedentarismo; consumo exagerado de sal; consumo de bebidas alcoólicas; predisposição genética; gênero e etnia (homens não branco são mais propensos a desenvolver hipertensão); tabagismo; diabetes; alterações nos níveis de colesterol e triglicérides; estresse; sono irregular; histórico familiar de doença cardiovascular prematura (menos de 55 anos para homens, e menos de 65 para mulheres; apneia do sono; hipertireoidismo; doenças renais; menopausa.</p>

<p><b> Sintomas</b></p>

<p>Na maioria dos casos, a hipertensão é uma doença silenciosa, sendo que os sintomas tendem a aparecer quando já está em fase mais avançada. Entre os sintomas da hipertensão estão: dores de cabeça; falta de ar; zumbido no ouvido; dores no peito; tonturas; falta de ar; visão turva.</p>

<p><b>Diagnóstico</b> </p>

<p>Por ser uma doença silenciosa, que apresenta sintomas no estágio mais avançado, a hipertensão pode ser difícil de ser diagnosticada. Por isso, é fundamental que a pessoa tenha sua pressão aferida com frequência.</p>

<p>Em consultas de rotina, é preciso informar se há casos de hipertensão na família, especialmente os pais. Além disso, deve-se informar ao profissional sobre o estilo de vida e os possíveis hábitos que podem influenciar no maior risco de hipertensão.</p>

<p>Para confirmar a hipertensão, é preciso que a medição seja realizada em três dias diferentes, sendo necessário seguir as orientações médicas para realização do exame. O médico pode solicitar, também, exames mais específicos, como o holter, que é um exame no qual a pressão é medida de maneira ininterrupta por 24 horas.</p>

<p>A hipertensão é classificada em três estágios:</p>

<p>- Estágio I: hipertensão acima de 130 por 90 e abaixo de 160 por 100</p>

<p>- Estágio II: hipertensão acima de 160 por 100 e abaixo de 180 por 110</p>

<p>- Estágio III: hipertensão acima de 180 por 110.</p>

<p>Gestantes precisam de uma atenção especial à pressão arterial, isso porque existe uma condição chamdaa pré-eclâmpsia, que é uma complicação caracterizada pelo aumento da pressão arterial na gravidez, levando a maior risco de parto prematuro e evolução para eclâmpsia, que é um quadro no qual a mulher tem convulsões, colocando em risco a sua vida e a do bebê.</p>

<p><b>Tratamento</b> </p>

<p>A hipertensão é uma doença que não tem cura, mas com o tratamento adequado ela pode ser controlada. O tratamento para hipertensão é individual, e deve ser planejado para cada paciente. O tratamento consiste na utilização de medicamentos para controle, que podem ser usados individualmente ou em conjunto e agir por diferentes mecanismos, sendo os mais comuns:</p>

<p>- Inibidor da enzima conversora da angiotensina: medicamentos que impedem a angiotensina I de se converter em angiotensina II, essa última responsável pelo aumento da pressão arterial.</p>

<p>- Antagonistas dos receptores da angiotensina (ARA): medicamentos que bloqueiam a ação da angiotensina II em um dos receptores que atua.</p>

<p>- Betabloqueadores: medicamentos que agem no sistema nervoso simpático, que tem como uma das funções reagir ao estresse.</p>

<p>- Diuréticos: medicamentos aumentam a excreção de água e sódio do organismo e também tem ação vasodilatadora, reduzindo a pressão sanguínea.</p>

<p>- Antagonistas de cálcio: medicamentos que bloqueiam a ação do canal de cálcio com consequente dilatação das artérias.</p>

<p>Contudo, é fundamental que o paciente adote mudanças no estilo de vida, mantendo o peso adequado, praticando atividades físicas, abandonando o tabagismo e o consumo de bebidas alcoólicas, moderando no consumo de sal e alimentos gordurosos, além de controlar o diabetes e outras comorbidades.</p>

<p> <b>Prevenção</b> </p>

<p>A prevenção da hipertensão passa pela adoção de um estilo de vida saudável: dieta saudável, rica em frutas, verduras e vegetais e pobre em gorduras e sal; cessação do tabagismo; controle (ou de preferência evitar) o consumo de bebidas alcoólicas; controle do estresse; boas noites de sono; e consultas médicas regulares&nbsp;<br>&nbsp;</p>
    


</app-card>